/* eslint-disable indent */
export const AUTH_URL = process.env.VUE_APP_AUTH_URL
export const AUTH_API_TOKEN = process.env.VUE_APP_UNOAPP_API_TOKEN
export const authToken = () => JSON.parse(localStorage.getItem('vuex')).auth.user.token

export const PERMISSIONS_URL = process.env.VUE_APP_PERMISSIONS_URL
export const PERMISSIONS_API_TOKEN = process.env.VUE_APP_PERMISSIONS_TOKEN

export const LOCATIONS_IDENTIFIER = process.env.VUE_APP_LOCATIONS_IDENTIFIER
export const LOCATION_URL = () => {
    if (JSON.parse(localStorage.getItem('vuex'))) {
        if (JSON.parse(localStorage.getItem('vuex')).permissions) {
            return JSON.parse(localStorage.getItem('vuex')).permissions.url
        }
    }
}
export const LOCATION_API_TOKEN = () => {
    if (JSON.parse(localStorage.getItem('vuex'))) {
        if (JSON.parse(localStorage.getItem('vuex')).permissions) {
            return JSON.parse(localStorage.getItem('vuex')).permissions.apiToken
        }
    }
}
